module.exports = __webpack_public_path__ + "static/media/instagramLogoHiRes.c72a612f.png";